// Metadados de <head> por brand (titulo, favicon, theme-color). Separado do
// BrandConfig porque o vite.config.ts tambem le estes valores pra gerar o
// index.html ja com a marca certa no build (aba do navegador antes do JS
// carregar, preview de link no WhatsApp etc). Sem imports de React/alias de
// proposito: o vite.config nao resolve '@/'.

export interface BrandHtmlMeta {
  displayName: string;
  faviconHref: string;
  themeColorMeta: string;
}

export const BRAND_HTML_META: Record<'just' | 'valepag', BrandHtmlMeta> = {
  just: {
    displayName: 'JUST Frotas',
    faviconHref: '/favicon.png',
    themeColorMeta: '#f45546',
  },
  valepag: {
    displayName: 'ValePag Frotas',
    faviconHref: '/brand/valepag/favicon.png',
    themeColorMeta: '#19b24b',
  },
};
